import { combineReducers } from '@reduxjs/toolkit';

import { activityReducer, feedReducer } from '@/entities/activity';
import { balloonReducer } from '@/entities/balloon';
import { gameMetaReducer } from '@/entities/game';
import { jettonReducer } from '@/entities/jetton';
import { leaderboardReducer } from '@/entities/leaderboard';
import { minesReducer } from '@/entities/mines';
import { preferencesReducer } from '@/entities/preferences';
import { referralReducer } from '@/entities/referral';
import { historyReducer,rollsReducer } from '@/entities/rolls';
import { userReducer } from '@/entities/user';
import { withdrawReducer } from '@/entities/withdraw';

export const rootReducer = combineReducers({
  user: userReducer,
  rolls: rollsReducer,
  history: historyReducer,
  jetton: jettonReducer,
  mines: minesReducer,
  balloon: balloonReducer,
  leaderboard: leaderboardReducer,
  referral: referralReducer,
  withdraw: withdrawReducer,
  activity: activityReducer,
  feed: feedReducer,
  gameMeta: gameMetaReducer,
  preferences: preferencesReducer,
});
